/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Improve_Modality_WhyInputs */

const en_us2_improve_modality_why = /** @type {(inputs: Improve_Modality_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where you come from changes how fast you can ramp.`)
};

const pt_br2_improve_modality_why = /** @type {(inputs: Improve_Modality_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De onde você vem muda a velocidade da progressão.`)
};

const es_419_improve_modality_why = /** @type {(inputs: Improve_Modality_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De dónde vienes cambia qué tan rápido puedes progresar.`)
};

const pt_pt2_improve_modality_why = /** @type {(inputs: Improve_Modality_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De onde vens muda a velocidade da progressão.`)
};

const fr_fr2_improve_modality_why = /** @type {(inputs: Improve_Modality_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton parcours change la vitesse à laquelle tu peux progresser.`)
};

const de_de2_improve_modality_why = /** @type {(inputs: Improve_Modality_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woher du kommst, bestimmt, wie schnell du steigern kannst.`)
};

const it_it2_improve_modality_why = /** @type {(inputs: Improve_Modality_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da dove vieni cambia la velocità con cui puoi progredire.`)
};

/**
* | output |
* | --- |
* | "Where you come from changes how fast you can ramp." |
*
* @param {Improve_Modality_WhyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const improve_modality_why = /** @type {((inputs?: Improve_Modality_WhyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Improve_Modality_WhyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_improve_modality_why(inputs)
	if (locale === "es-419") return es_419_improve_modality_why(inputs)
	if (locale === "pt-PT") return pt_pt2_improve_modality_why(inputs)
	if (locale === "fr-FR") return fr_fr2_improve_modality_why(inputs)
	if (locale === "de-DE") return de_de2_improve_modality_why(inputs)
	if (locale === "it-IT") return it_it2_improve_modality_why(inputs)
	return en_us2_improve_modality_why(inputs)
});
export { improve_modality_why as "improve.modality.why" }